import { X } from 'lucide-react'
import { useStudioStore } from '@/store/studio-store'
import { LibrarySurface } from './surfaces/library-surface'

export function ResourcesDrawer() {
  const open = useStudioStore((s) => s.resourcesDrawerOpen)
  const close = useStudioStore((s) => s.closeResourcesDrawer)

  if (!open) return null

  return (
    <aside
      aria-label="Coogo ontology"
      data-testid="resources-drawer"
      className="absolute inset-y-0 right-0 z-30 flex w-full max-w-[640px] flex-col border-l border-border bg-background shadow-2xl"
    >
      <button
        type="button"
        onClick={close}
        aria-label="Close Coogo ontology"
        className="absolute right-3 top-3 z-10 inline-flex h-8 w-8 items-center justify-center rounded-md border border-border bg-background text-muted-foreground hover:bg-muted hover:text-foreground"
      >
        <X className="h-4 w-4" />
      </button>
      <LibrarySurface />
    </aside>
  )
}
